// extracted by mini-css-extract-plugin
export default {"deliveryTypeText":"SelectedDeliveryTypeSection_deliveryTypeText__XmSEu"};